import React, { useEffect, useState } from 'react';
import { Button, Header, Icon, Message, Table, Modal } from 'react-frontier2';
import { useTranslation } from 'react-i18next';
import { AssetRelations, AssetFile } from '../AdminClasses';
import { Link } from 'react-router-dom';
import { SetLoading } from '@arema/components/Classes';
import moment from 'moment';
import API from '../API';

interface DeleteAssetModalProps{
	open: boolean,
	onClose: ()=>void,
	asset: AssetFile,
	data: AssetRelations,
	tableData?: any[][],
	onDeleted: (asset_id: number)=>void,
}

var DeleteAssetModal = (props: DeleteAssetModalProps)=>{
	var { t } = useTranslation();
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
	
	var deleteAsset = (setLoading: SetLoading)=>{
		setLoading(true);
		API.deleteAsset(props.asset.asset_id, props.data).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			props.onDeleted(props.asset.asset_id);
			if(props.onClose) props.onClose();
		}).catch(err=>{
			return setModalPrompts([t('common.unexpected_code', { code: 'LCL-DLASMDL-1' })])
		}).finally(()=>{
			setLoading(false);
		})
	}
	
	return <Modal open={props.open} onClose={props.onClose} size='tiny'>
		<Modal.Header>Eliminar archivo</Modal.Header>
		{!!props.open && <Modal.Content>
			<Header text='¿Eliminar archivo?' subtext={'Se eliminará por completo el archivo seleccionado'} />
			<Table details>
				<Table.Head title='Evidencia' titleSize='small' />
				<Table.Body data={[
					...(props.tableData || []),
					[t('common.file'), props.asset.asset_name],
					[t('common.date_created'), moment.unix(props.asset.date_created).format('DD/MMM/YY HH:mm')],
					[t('common.link'), (
						<Link to={props.asset.download_url} target='_blank' style={{ color: '#4183c4', padding: 0 }}>
							<Icon name='external-link' /> Ver archivo
						</Link>
					)]
				]} />
			</Table>
			<Message type='error' list={modalPrompts} />
		</Modal.Content>}
		<Modal.Actions>
			<Button text='Cerrar' basic onClick={props.onClose} />
			<Button text='Eliminar' color='red' onClick={deleteAsset} />
		</Modal.Actions>
	</Modal>
}

export default DeleteAssetModal;